// extracted by mini-css-extract-plugin
export default {"main":"ChangePermanentUser_main__qhaAr"};